module.exports = __webpack_public_path__ + "static/img/tuijian.9ec76a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/tuijian.jpg
// module id = 178
// module chunks = 2